module.exports = __webpack_public_path__ + "static/media/business.1cfaba95.svg";